// from vue and vuex
import { defineComponent } from 'vue'
import { mapGetters ,mapActions } from 'vuex'

// Component
export default defineComponent ({
    name: 'HTDetailsArea',
    components:  {
      pagination: () => import('laravel-vue-pagination')
    },
    props: {
        sveId: Number,
        show: Boolean
    },
    data: () => ({
        processing: true,
        processingChangePageOperative: false,
        processingChangePageAdministrative: false,
    }),
    watch: {
      async sveId() {
          this.processing = true
          await this.getHTGESDashboardSVE({id: this.sveId }).finally(() => {
              this.processing = false
          })
      }
    },
    computed: {
        ...mapGetters('htGesV2', [
            'getGESAdministrative',
            'getGESOperative'
        ]),
        /**
         * Operative
         */
        fieldsOperative () {
            return [
                {
                    key: 'name',
                    label: 'Operativo'
                },
                {
                    key: 'count_employees',
                    label: 'Cantidad'
                }
            ]
        },

        /**
         * Administrative
         */
        fieldsAdministrative () {
            return [
                {
                    key: 'name',
                    label: 'Administrativo'
                },
                {
                    key: 'count_employees',
                    label: 'Cantidad'
                }
            ]
        },
    },
    methods: {
        ...mapActions('htGesV2', [
            'getHTGESDashboardSVE',
            'getHTGESDashboardSVEChangePageType'
        ]),
        async changePageGESOperative (page = 1) {
            this.processingChangePageOperative = true
            await this.getHTGESDashboardSVEChangePageType({id: this.sveId, data: { page, type: 'operative' }}).finally(() => {
                this.processingChangePageOperative = false
            })
        },
        async changePageGESOAdministrative (page = 1) {
            this.processingChangePageAdministrative = true
            await this.getHTGESDashboardSVEChangePageType({id: this.sveId, data: { page, type: 'administrative' }}).finally(() => {
                this.processingChangePageAdministrative = false
            })
        }
    }
})

